import React from "react";
import PropTypes from "prop-types";

const EntitySvg = ({ height = "18", width = "18", viewBox = "0 0 18 18" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M1.92857 3C0.871373 3 0 3.81328 0 4.8V13.2C0 14.1867 0.871373 15 1.92857 15H16.0714C17.1286 15 18 14.1867 18 13.2V4.8C18 3.81328 17.1286 3 16.0714 3H1.92857ZM1.92857 4.2H16.0714C16.4355 4.2 16.7143 4.46016 16.7143 4.8V13.2C16.7143 13.5398 16.4355 13.8 16.0714 13.8H1.92857C1.56445 13.8 1.28571 13.5398 1.28571 13.2V4.8C1.28571 4.46016 1.56445 4.2 1.92857 4.2ZM5.78571 5.4C4.37193 5.4 3.21429 6.48047 3.21429 7.8C3.21429 8.46797 3.52065 9.07031 3.99777 9.50625C3.14146 10.0477 2.57143 10.9688 2.57143 12H3.85714C3.85714 10.9992 4.71345 10.2 5.78571 10.2C6.85798 10.2 7.71429 10.9992 7.71429 12H9C9 10.9688 8.42997 10.0477 7.57366 9.50625C8.05078 9.07031 8.35714 8.46797 8.35714 7.8C8.35714 6.48047 7.1995 5.4 5.78571 5.4ZM10.2857 6V7.2H15.4286V6H10.2857ZM5.78571 6.6C6.50391 6.6 7.07143 7.12969 7.07143 7.8C7.07143 8.47031 6.50391 9 5.78571 9C5.06752 9 4.5 8.47031 4.5 7.8C4.5 7.12969 5.06752 6.6 5.78571 6.6ZM10.2857 8.4V9.6H15.4286V8.4H10.2857ZM10.2857 10.8V12H13.5V10.8H10.2857Z"
        fill="white"
      />
    </svg>
  );
};

EntitySvg.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  viewBox: PropTypes.string,
};

export default EntitySvg;
